import { ShowProcessStepRecordingRequestSchema, ShowProcessStepRecordingResponseSchema } from './show-process-step-recording.schema';
/**
 * Show Process Step Recording Endpoint Contract
 * Retrieves a specific process step recording by ID
 */ export const showProcessStepRecordingContract = {
    method: 'GET',
    path: '/api/v2/process-step-recording/:id',
    description: 'Retrieve a specific process step recording by ID',
    requestSchema: ShowProcessStepRecordingRequestSchema,
    responseSchema: ShowProcessStepRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized - user not authenticated',
            404: 'Process step recording not found'
        }
    }
};

//# sourceMappingURL=show-process-step-recording.contract.js.map